export default __webpack_public_path__ + "static/media/undraw_sales_and_marketing.1d71f8e5.svg";